import { useMemo } from 'react';

export const useIsOnSemanticSearch = () => {
	const hasSearchQuery = useMemo(() => {
		const searchParams = new URLSearchParams(window.location.search);
		return searchParams.has('q');
	}, []);

	return { isOnSemanticSearch: hasSearchQuery };
};
